<template>
    <modal @close="$emit('close')" width="95%" max-width="375px" :click-backdrop-closing="false">
        <div slot="title">{{$t('sms_verification')}}</div>
        <div class="modal-content-wrapper px-3 my-2">
            <p class="mx-4" v-if="showContactInfo" v-html="$t('sms.fail_to_receive_message')"></p>
            <div v-else>
                <p class="explanation">
                    {{$t('explanation')}}
                </p>
                <p v-if="sentAt && !isEditing">{{$t('sent_text')}}</p>
                <p v-if="isSending">{{$t('sending')}}</p>
                <div v-if="!isSending">
                    <div v-if="isEditing" class="d-flex mb-4 align-items-start mb-5">
                        <vue-phone-input
                            v-if="isEditing"
                            style="flex-grow:1"
                            ref="phone-input"
                            name="phone"
                            :code="localCountryItem.code"
                            :value="localPhoneNumber"
                            :onChange="onPhoneNumberChange"
                            :placeholder="$t('message.customer_phone_placeholder')"
                        />
                        <div class="text-right">
                            <button class="btn btn-sm btn-secondary ml-2" @click="endEditingNumber">{{$t('general.modify')}}</button>
                            <button class="btn btn-sm btn-danger ml-2" @click="onCancelEditingNumber">{{$t('general.cancel')}}</button>
                        </div>
                    </div>
                    <div v-else class="phone-number d-flex align-items-center">
                        <div style="flex-grow:1">{{`+${localPhoneCallingCode}-${localPhoneNumber}`}}</div>
                    </div>
                </div>
                <input ref="input" v-if="!isSending && !isEditing" v-model="code" :placeholder="$t('please_enter_sms_code')" class="form-control form-contorl-sm code-input mt-4" />
                <div v-if="!isSending && !isEditing && codeExpiredAt" class="text-right mb-3">
                    {{$t('message.code_expired_at', {expiredAt: codeExpiredAt.format('YYYY-MM-DD A h:mm')}) }}
                </div>
                <div v-if="freezeCounterToken && freezeCounter > 0 && !isEditing" class="text-xs text-right text-muted flex">
                    <div>{{$t('n_seconds_left_to_resend', {seconds: freezeCounter})}}</div>
                    <div class="text-right">
                        <a @click="isEditing = true" class="text-secondary" href="javascript:void(0);"><small>{{$t('edit_number')}}</small></a>
                    </div>
                </div>
                <div class="d-flex mt-1 justify-content-between" v-else-if="!isEditing">
                    <div>
                        <a @click="showContactInfo = true" class="text-secondary" href="javascript:void(0);"><small>{{$t('cannot_receive_code')}}</small></a>
                    </div>
                    <div  class="text-right">
                        <a @click="doGetSMSCode" class="text-secondary" href="javascript:void(0);"><small>{{$t('resend')}}</small></a>
                        <br>
                        <a @click="isEditing = true" class="text-secondary" href="javascript:void(0);"><small>{{$t('edit_number')}}</small></a>
                    </div>
                </div>

                <p class="text-danger mt-4" v-if="errors" v-html="errors"></p>
                <div class="mb-2 mt-4 text-center">
                    <button v-if="!isEditing && !isSending" class="btn btn-primary btn-block" @click="submitCode">{{$t('verify')}}</button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import api from '../../mixins/api';
import moment from 'moment';
import vuePhoneInput from '../../components/vue-phone-input/index.vue';
import { EventRequestSmsVerification } from '../../bu/models/GA4';
import { isValidPhoneNumber } from 'libphonenumber-js';

export default {
    components: { vuePhoneInput},
    mixins: [api],
    props: {
        countryItem: {required: true, type: Object},
        phoneNumber: {required: true, type: String},
    },
    data() {
        return {
            isSending: false,
            sentAt: null,
            isEditing: false,
            code: '',
            localCountryItem: this.countryItem,
            localPhoneCallingCode: this.countryItem.dialCode,
            localPhoneNumber: this.phoneNumber,
            freezeCounterToken: null,
            freezeCounter: 0,
            hasPhoneNumberUpdated: false,
            errors: '',
            showContactInfo: false,
            codeExpiredAt: null
        }
    },
    mounted() {
        this.doGetSMSCode();
    },
    computed: {
        hasValidPhoneCallingCode() {
            return !!this.localPhoneCallingCode && !!this.localCountryItem?.code;
        },
        hasValidPhoneNumber() {
            return !!this.localCountryItem?.code && isValidPhoneNumber(this.localPhoneNumber, this.localCountryItem?.code?.toUpperCase());
        },
    },
    methods: {
        submitCode() {
            this.$emit('sms-code-input', {
                code: this.code,
                phoneNumber: this.localPhoneNumber,
                phoneCallingCode: this.localPhoneCallingCode
            });
        },
        doGetSMSCode() {
            this.errors = '';
            if (!this.hasValidPhoneCallingCode || !this.hasValidPhoneNumber) {
                this.errors = this.$t('message.please_fill_your_phone');
                return;
            }
            this.isSending = true;
            this.getSMSCode(this.localPhoneCallingCode, this.localPhoneNumber, (response, error, errors) => {
                this.isSending = false;
                this.trackRequestSmsVerification(!error);
                if (!error) {
                    this.sentAt = new Date();
                    this.codeExpiredAt = moment().add(10, 'minute');
                    this.freezeCounter = 60;
                    this.freezeCounterToken = setInterval(() => {
                        this.freezeCounter -= 1;
                        if (this.freezeCounter <= 0) {
                            clearInterval(this.freezeCounterToken);
                            this.freezeCounterToken = null;
                        }
                    }, 1000);
                    setTimeout(() => {
                        this.$refs['input'].focus();
                    }, 200)
                } else if (errors) {
                    this.errors = errors.map((e) => this.$t(e)).join("<br>")
                }
            });
        },
        onPhoneNumberChange(phoneInputComponent) {
            this.localPhoneNumber = phoneInputComponent.phoneNumber;
            this.localPhoneCallingCode = new String( phoneInputComponent.availableData[phoneInputComponent.countryCode].dialCode);
            this.localCountryItem = phoneInputComponent.availableData[phoneInputComponent.countryCode];
            this.hasPhoneNumberUpdated = true;
        },
        endEditingNumber() {
            this.errors = '';
            if (!this.hasValidPhoneCallingCode || !this.hasValidPhoneNumber) {
                this.errors = this.$t('message.please_fill_your_phone');
                return;
            }
            if (this.hasPhoneNumberUpdated) {
                this.doGetSMSCode();
                this.hasPhoneNumberUpdated = false;
            }

            this.isEditing = false;
        },
        trackRequestSmsVerification(isSuccess) {
            window.tracker.track(() => new EventRequestSmsVerification('booking', isSuccess));
        },
        onCancelEditingNumber() {
            this.localPhoneNumber = this.phoneNumber;
            this.localPhoneCallingCode = this.countryItem.dialCode;
            this.isEditing = false;
        }
    }

}
</script>

<style scoped lang="scss">

/deep/ .intl-phone-input {
    width: auto !important;
}

/deep/ .intl-phone-input.allow-dropdown .country-list {
    white-space: normal;
    max-height: 70px;
}

.explanation {
    font-size: 16px;
}

</style>

<i18n>
    {
        "zh": {
            "sms_verification": "手機號碼驗證",
            "explanation": "確保聯絡暢通，請進行手機號碼驗證。",
            "sent_text": "驗證碼已發送至以下號碼，請輸入您收到的驗證碼以繼續預約。",
            "verify": "送出驗證",
            "sending": "正在送出驗證碼...",
            "edit_number": "修改號碼",
            "please_enter_sms_code": "請輸入六碼驗證碼",
            "n_seconds_left_to_resend": "{seconds} 秒後可重新發送",
            "resend": "重新發送驗證碼",
            "errors.fail_to_get_code": "目前無法取得驗證碼，請直接聯絡我們。",
            "cannot_receive_code": "無法收到驗證碼？"
        },
        "en": {
            "sms_verification": "Verify Your Phone Number",
            "explanation": "For better communication, please verify your phone number.",
            "sent_text": "An verification code has been sent to below number, please enter the code received to proceed.",
            "verify": "Verify",
            "sending": "Sending verification code...",
            "edit_number": "Edit Number",
            "please_enter_sms_code": "Please enter 6-digit code",
            "n_seconds_left_to_resend": "You can resend SMS code after {seconds} seconds",
            "resend": "Resend SMS code",
            "errors.fail_to_get_code": "Fail to get SMS code temporarily, please contact us directly.",
            "cannot_receive_code": "Can't receive code?"
        }
    }
</i18n>